export default __webpack_public_path__ + "static/media/Foresters.554c2eb7.svg";